import request from '@/utils/request'

let FileApi = {

    /*文件类别列表*/
    fileCategory(data) {
        return request._post('/shop/file.file/category', data);
    },

    /*文件列表*/
    fileList(data) {
        return request._post('/shop/file.file/lists', data);
    },

    /*删除多文件*/
    deleteFiles(data) {
        return request._post('/shop/file.file/deleteFiles', data);
    },

    /*添加文件分类*/
    addCategory(data) {
        return request._post('/shop/file.file/addGroup', data);
    },

    /*修改文件分类*/
    editCategory(data) {
        return request._post('/shop/file.file/editGroup', data);
    },

    /*删除文件分类*/
    deleteCategory(data) {
        return request._post('/shop/file.file/deleteGroup', data);
    },

    /*上传*/
    uploadFile(formData) {
        return request._upload('/shop/file.upload/image', formData);
    },
    /*移动文件*/
    moveFile(formData) {
        return request._upload('/shop/file.upload/moveFiles', formData);
    },


}

export default FileApi;



// WEBPACK FOOTER //
// ./src/api/file.js